<header class="position__relative header_container">
  <img class="hero_header_img" src="assets/img/obd22.png">
  <div class="header_text scroll-animations container-fluid">
    <div class="header_text_container position__relative">
      <h1 class="header_title animated mb-3">ONBOARDING ZEEKER</h1>

    </div>

  </div>
</header>

<section id="OCR" class="section-bg-gradient mb-25px">
  <div class="container">
    <div class="row mb-25px">
      <div class="col-sm-12 ">
        <h2 class="align__text-center">SERVICIO ÁGIL DE CONTRATACIÓN</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <p class="font-medium">Presentamos la solución OBD Zeeker, que permite realizar el proceso de Contratación y
          Registro Digital a través del alta mediante la identificación digital de personas, prueba de vida y firma
          digital avanzada y cualificada.</p>
      </div>
      <div class="col-12 mt-4">
        <img class="w-100" src="assets/img/obd_proguress.png" alt="">
      </div>
    </div>

  </div>
</section>

<section class="section-bg-clear mb-25px">
  <div class="container">
    <div class="row">
      @for (card of cards; track card) {
      <div class="col-12 col-md-6 mb-4">
        <div class="obd-card">
          <div class="row">
            <div class="col-6 pr-0">
              <img class="w-100 h-100" src="{{ card.icon }}" alt="img">
            </div>
            <div class="col-6 pl-0 d-flex flex-column align-items-center justify-content-center">
              <p class="green title-card">{{ card.title }}</p>
              <p>{{ card.description }} </p>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</section>

<section class="section-bg-clear mb-25px">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h2 class="align__text-center">VENTAJAS DE INTEGRAR EL OBD DE ZEEKER</h2>
      </div>
      <div class="col-12 mt-5 d-flex flex-row justify-content-center flex-wrap">
        @for (advantage of advantages.slice(0, 3); track advantage) {
          <div class="obd-why mb-3">
          <img class="w-100" src="{{ advantage.icon }}" alt="icon">
          <p class="green">{{ advantage.title }}</p>
          <p>{{ advantage.description }}</p>
        </div>
        }

      </div>
      <div class="col-12 mt-5 d-flex flex-row justify-content-center flex-wrap">
        @for (advantage of advantages.slice(3, 6); track advantage) {
          <div class="obd-why mb-3">
          <img class="w-100" src="{{ advantage.icon }}" alt="icon">
          <p class="green">{{ advantage.title }}</p>
          <p>{{ advantage.description }}</p>
        </div>
        }

      </div>
    </div>
  </div>
</section>
<section class="bg-section-clear mb-5">
  <div class="container">
    <div class="row">
      <div class="col-12 col-sm-6 d-flex flex-column align-items-center justify-content-center">
        <h5 class="">VENTAJAS DE INTEGRAR EL OBD DE ZEEKER</h5>
        <p>KYC, o Know Your Customer, es la práctica de las empresas de verificar la identidad de sus clientes en
          cumplimiento de los requisitos legales y la normativa vigente.</p>
        <h5 class="mt-5 align-self-start">¿QUÉ ES FIRMA DIGITAL?</h5>
        <p>Permite a las organizaciones firmar en cualquier momento y desde cualquier dispositivo.
          Se adapta a cualquier nivel de riesgo en cualquier operación empresarial ambas firmas:</p>
        <ul class="green align-self-start">
          <li>Firma Digital Avanzada </li>
          <li>Firma Digital Cualificada</li>
        </ul>
        <p> La integración se puede realizar en la web del cliente o en una aplicación nativa en cuestión de horas.</p>
      </div>
      <div class="col-12 col-sm-6">
        <img src="assets/img/obd-kyc.png" alt="" class="w-100">
      </div>

    </div>
    <div class="row mt-5">
      <div class="col-12">
        <p class="align__text-center">Nuestro valor es la gestión única de datos que ponemos a tu disposición.</p>
      </div>
    </div>
  </div>
</section>
<section id="OCR" class="section-bg-clear mb-25px">
  <div class="container">
    <div class="row mb-25px">
      <div class="col-sm-12 ">
        <h2 class="align__text-center">SEGURIDAD GARANTIZADA</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex justify-content-center">
        <img src="assets/img/logos.png" alt="" class="w-100">
      </div>
    </div>

  </div>
</section>
<!-- <section class="mb-5 position__relative header_container">
  <img class="hero_header_img" src="assets/img/bg-use.png">
  <div class="header_text_clean scroll-animations container-fluid">
    <div class="header_text_container position__relative">
      <h1 class="header_title animated mb-3">OPCIONES DE USO</h1>
    </div>
  </div>
</section> -->